<template>
  <div>
    <b-row class="match-height">
      <b-col :md="CHECKOUT_DATA.separateBillingAddress.selected ? 6 : 12">
        <b-card title="VertragspartnerIn (Anschlussort)">
          <p>
            <template v-if="this.CHECKOUT_DATA.b2b_funnel_active">
              {{ CHECKOUT_DATA.billingAddress.company }}<br/>
            </template>
            {{ getSalution(CHECKOUT_DATA.billingAddress.salutation) }} {{ CHECKOUT_DATA.billingAddress.firstname }} {{ CHECKOUT_DATA.billingAddress.name }} <br/>
            {{ CHECKOUT_DATA.billingAddress.street }} {{ CHECKOUT_DATA.billingAddress.housenumber }} <br/>
            {{ CHECKOUT_DATA.billingAddress.postcode }} {{ CHECKOUT_DATA.billingAddress.city }}<br/>

            <br/>
            <template v-if="!this.CHECKOUT_DATA.b2b_funnel_active">
            Geburtstag: {{ formatDate(CHECKOUT_DATA.billingAddress.birthday) }}<br/><br/>
            </template>

            <span v-if="CHECKOUT_DATA.billingAddress.apartment_informations">
              Wohnungslage: {{ CHECKOUT_DATA.billingAddress.apartment_informations }}
            </span>
          </p>
          <p class="mt-2">
            Telefon: {{ CHECKOUT_DATA.billingAddress.phone }}<br/>
            E-Mail: {{ CHECKOUT_DATA.billingAddress.email }}
          </p>
          <p class="mt-2" v-if="CHECKOUT_DATA.bankaccount.iban != ''">
            Kontoinhaber: {{ CHECKOUT_DATA.bankaccount.firstname }}
            <template v-if="!this.CHECKOUT_DATA.b2b_funnel_active">
              {{ CHECKOUT_DATA.bankaccount.name }}
            </template><br/>
            IBAN: {{ CHECKOUT_DATA.bankaccount.iban }}<br/>

            <span class="d-block" v-if="false">
              Abweichender Kontoinhaber:<br/>
              {{ getSalution(CHECKOUT_DATA.bankaccount.address.salutation) }}  {{ CHECKOUT_DATA.bankaccount.address.firstname }} {{ CHECKOUT_DATA.bankaccount.address.name }} <br/>
              {{ CHECKOUT_DATA.bankaccount.address.street }}<br/>
              {{ CHECKOUT_DATA.bankaccount.address.postcode }} {{ CHECKOUT_DATA.bankaccount.address.city }}
            </span>
          </p>

          <p class="mt-2" v-if="CHECKOUT_DATA.promoter != '' && CHECKOUT_DATA.promoter != null">
            Promoter: {{ CHECKOUT_DATA.promoter }}<br/>
          </p>
        </b-card>
      </b-col>
      <b-col md="6" v-if="CHECKOUT_DATA.separateBillingAddress.selected">
        <b-card title="Abweichende Rechnungsadresse">
          <template v-if="this.CHECKOUT_DATA.b2b_funnel_active">
            {{ CHECKOUT_DATA.separateBillingAddress.company }}<br/>
          </template>
          {{ getSalution(CHECKOUT_DATA.separateBillingAddress.salutation) }} {{ CHECKOUT_DATA.separateBillingAddress.firstname }} {{ CHECKOUT_DATA.separateBillingAddress.name }} <br/>
          {{ CHECKOUT_DATA.separateBillingAddress.street }}<br/>
          {{ CHECKOUT_DATA.separateBillingAddress.postcode }} {{ CHECKOUT_DATA.separateBillingAddress.city }}
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card title="Abweichende Lieferadresse" v-if="CHECKOUT_DATA.separateDeliveryAddress.selected">
          {{ getSalution(CHECKOUT_DATA.separateDeliveryAddress.salutation) }} {{ CHECKOUT_DATA.separateDeliveryAddress.firstname }} {{ CHECKOUT_DATA.separateDeliveryAddress.name }} <br/>
          {{ CHECKOUT_DATA.separateDeliveryAddress.street }}<br/>
          {{ CHECKOUT_DATA.separateDeliveryAddress.postcode }} {{ CHECKOUT_DATA.separateDeliveryAddress.city }}
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import {
  BFormRadioGroup,
  BFormGroup,
  BFormInput, BCol, BRow, BFormDatepicker, BFormCheckbox, BCard
} from "bootstrap-vue";

export default {
  name: "AddressSummary",
  components: {
    BFormRadioGroup,
    BFormGroup,
    BFormDatepicker,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BCard
  },
  data() {
    return {
      address: {},
      value: [],
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    formatDate(datestring) {
      let options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      };
      let date = new Date(datestring)

      return date.toLocaleDateString('de-DE', options)
    },
    getSalution(salution) {
      return (salution === 'female' ? 'Frau' : 'Herr')
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
  .card-title {
    font-size: 16px;
    font-weight: bold;
  }
</style>
